export const Credit = () => (
  <footer className="wrap credit-foot" data-testid="credit-footer">
    <a className="credit" href="https://dhwaniris.com" target="_blank" rel="noopener noreferrer" data-testid="credit-link">
      <img src="/brand/dhwani-logo-full.png" alt="Dhwani RIS" width="53" height="20" />
      <span>Developed by <b>dhwaniris.com</b></span>
    </a>
  </footer>
);
